// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Border / focus / error / disabled come from .cui-control */
.cui-control.cta-textarea { /* paired with .cui-control: wins regardless of CSS load order */
  min-height: calc(var(--cui-control-height) * 2);
  padding-top: 9px;
  padding-bottom: 9px;
  line-height: 1.5;
  overflow-wrap: break-word;
}

.cta-counter {
  align-self: flex-end;
  font-size: var(--cui-font-size-sm);
  color: var(--cui-text-muted);
  font-variant-numeric: tabular-nums;
}

.cta-counter-limit {
  color: var(--cui-danger);
  font-weight: 600;
}
`, "",{"version":3,"sources":["webpack://./src/Component/CustomTextArea/CustomTextArea.css"],"names":[],"mappings":"AAAA,6DAA6D;AAC7D,4BAA4B,gEAAgE;EAC1F,+CAA+C;EAC/C,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,kCAAkC;EAClC,4BAA4B;EAC5B,kCAAkC;AACpC;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;AAClB","sourcesContent":["/* Border / focus / error / disabled come from .cui-control */\n.cui-control.cta-textarea { /* paired with .cui-control: wins regardless of CSS load order */\n  min-height: calc(var(--cui-control-height) * 2);\n  padding-top: 9px;\n  padding-bottom: 9px;\n  line-height: 1.5;\n  overflow-wrap: break-word;\n}\n\n.cta-counter {\n  align-self: flex-end;\n  font-size: var(--cui-font-size-sm);\n  color: var(--cui-text-muted);\n  font-variant-numeric: tabular-nums;\n}\n\n.cta-counter-limit {\n  color: var(--cui-danger);\n  font-weight: 600;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
